import React from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { get } from 'react-hook-form';
import { sanitizeAutoComplete } from './sanitize-auto-complete';

export type CustomTextFieldProps = Partial<TextFieldProps> & {
  errors?: Record<string, any>;
  helperText?: string;
  name: string;
};

export const CustomTextField = React.forwardRef<
  HTMLInputElement,
  CustomTextFieldProps
>(({ errors, name, helperText, ...rest }, ref) => {
  const error = get(errors, name);
  let label = rest.label || '';
  if (typeof label === 'string' && rest.required && label.match(/\s\*$/)) {
    label = label.replace(/\s\*$/, '');
  }

  // Handle both v6 inputRef and v7 ref from register spread
  const inputRefValue = rest.inputRef || ref;
  const { inputRef, ...restWithoutInputRef } = rest;
  const autoComplete = sanitizeAutoComplete(restWithoutInputRef.autoComplete);

  return (
    <TextField
      error={Boolean(error) || errors?.isError}
      helperText={error?.message || helperText}
      fullWidth
      variant="outlined"
      name={name}
      {...restWithoutInputRef}
      autoComplete={autoComplete}
      label={label}
      inputRef={inputRefValue}
    />
  );
});
CustomTextField.displayName = 'CustomTextField';
